import {Clock, LucideIcon} from 'lucide-react';
import * as React from 'react';

import {Badge} from '../badge/Badge';
import {Card} from '../card/Card';
import {IconChip} from '../icon-chip/IconChip';

export interface PanelProps extends React.PropsWithChildren {
    icon: LucideIcon;
    title: string;
    comingSoon?: boolean;
    comingSoonLabel?: string;
    danger?: boolean;
    className?: string;
}

export const Panel: React.FunctionComponent<PanelProps> = ({icon, title, comingSoon, comingSoonLabel = 'Coming soon', danger, className, children}: PanelProps) => (
    <Card as="section" muted={comingSoon} className={className}>
        <div className="mp-panel__header">
            <IconChip icon={icon} tone={danger ? 'danger' : 'brand'}/>
            <h2 className="mp-panel__title">{title}</h2>
            {comingSoon && <Badge icon={Clock}>{comingSoonLabel}</Badge>}
        </div>
        {children}
    </Card>
);
